<div class="slide">
    <msc-heading-actions>
        <h2 class="heading">
            {{ sectionContent?.title }}
        </h2>
    </msc-heading-actions>

    <ng-container *ngIf="isReady()">
        <!-- Respaldo: abrir o reabrir el paquete a mano -->
        <div (click)="launch()" class="mb-2 card card-background" *ngIf="state === 'idle'">
            <div class="card__text" style="margin: auto;">
                <svg role="img" xmlns="http://www.w3.org/2000/svg" width="56px" height="56px" viewBox="0 0 24 24" aria-labelledby="videoIconTitle videoIconDesc" stroke="#5b70ff" stroke-width="1.2857142857142858" stroke-linecap="square"
                    stroke-linejoin="miter" fill="none" color="#5b70ff">
                    <polygon points="18 12 9 16.9 9 7" />
                    <circle cx="12" cy="12" r="10" />
                </svg>

                <p>{{ 'player.section-content.scorm.open-modal' | translate }}</p>
            </div>
        </div>

        <div class="mb-2 card card-background" *ngIf="state !== 'idle'">
            <div class="card__text" style="margin: auto;">
                <div class="lds-ring">
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                </div>

                <p>{{ (state === 'syncing' ? 'player.scorm.retrieve-progress' : 'player.scorm.loading-content') | translate }}</p>
            </div>
        </div>
    </ng-container>

    <!-- Etiqueta del tipo de contenido, debajo del embed -->
    <span class="block text-sm font-normal text-gray-600 my-2 px-4 py-3 bg-gray-50 border-t border-gray-200">{{ 'player.scorm.name' | translate }}</span>

    <msc-next-prev-btn [type]="'scormcloud'" [doneAt]="sectionContentSession?.doneAt"></msc-next-prev-btn>
</div>

<ng-template #modalFullScreen let-modal>
    <div class="modal-header">
        <span></span>
        <button type="button" class="close" aria-label="Close" (click)="modal.close()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body" style="display: flex; flex-direction: column;">
        <div class="modal-scorm" *ngIf="!iframeLoaded">
            <div class="lds-ring">
                <div></div>
                <div></div>
                <div></div>
                <div></div>
            </div>
        </div>

        <div class="modal-scorm" style="height: 100%;" [ngStyle]="{'display': iframeLoaded ? 'block' : 'none'}">
            <iframe *ngIf="url" [src]="url" (load)="onIframeLoad($event)" frameborder="0" width="100%" height="100%" allow="autoplay; fullscreen" allowfullscreen></iframe>
        </div>
    </div>
</ng-template>

<app-footer [context]="'scorm'" [contextId]="scorm?.id"></app-footer>
